import React, { useState } from 'react';
import './Gallery.css';

const images = [
  {
    src: '/anytimemovers1.webp',
    alt: 'Any Time Movers AU',
    caption: 'On the day of Big Project.',
  },
  {
    src: '/anytimemovers2.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers3.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers4.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers5.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers6.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers7.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers8.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers9.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers10.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers11.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers12.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers13.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers14.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers15.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers16.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers17.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers18.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers19.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
  {
    src: '/anytimemovers20.webp',
    alt: 'Any Time Movers AU',
    caption: 'Any Time Movers AU',
  },
];

const Gallery = () => {
  const [modalIndex, setModalIndex] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Set SEO title
  React.useEffect(() => {
    document.title = "Gallery - Any Time Movers AU | Adelaide Removalist Photos";
  }, []);

  const openModal = (index) => {
    setModalIndex(index);
  };

  const closeModal = () => {
    setModalIndex(null);
  };

  const transitionImage = (newIndex) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setModalIndex(newIndex);
      setTimeout(() => setIsTransitioning(false), 50);
    }, 250);
  };

  const prevImage = (e) => {
    e.stopPropagation();
    const newIndex = modalIndex === 0 ? images.length - 1 : modalIndex - 1;
    transitionImage(newIndex);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    const newIndex = modalIndex === images.length - 1 ? 0 : modalIndex + 1;
    transitionImage(newIndex);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <h2>Any Time Movers AU Gallery</h2>
        <p>See our professional Adelaide removalist team in action</p>
      </section>

      <div className="gallery-grid">
        {images.map((img, i) => (
          <div
            key={i}
            onClick={() => openModal(i)}
            className="gallery-item"
            aria-label={`Open image: ${img.alt}`}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
            />
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalIndex !== null && (
        <div
          onClick={closeModal}
          className="modal-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-title"
          tabIndex={-1}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="modal-content"
          >
            <button
              onClick={closeModal}
              className="modal-close"
              aria-label="Close modal"
            >
              &times;
            </button>

            <img
              src={images[modalIndex].src}
              alt={images[modalIndex].alt}
              className={`modal-image ${isTransitioning ? 'fade-out' : 'fade-in'}`}
            />
            <p
              id="modal-title"
              className="modal-caption"
            >
              {images[modalIndex].caption}
            </p>
            <div className="image-counter">
              {modalIndex + 1} / {images.length}
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevImage}
              className="modal-nav prev"
              aria-label="Previous image"
            >
              ‹
            </button>
            <button
              onClick={nextImage}
              className="modal-nav next"
              aria-label="Next image"
            >
              ›
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
